const imgTeamGraphic2HoverPostcards = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img2026923382 = "./assets/figma/582cbe0b-bff9-41c1-be6a-32d19f11e1a0.png";
const img2026923372 = "./assets/figma/06d5533b-ffa3-4942-a40c-4910afc87dee.png";
const img2026923373 = "./assets/figma/01051303-3827-4a66-ab58-6b9c95b95078.png";
const img2026923383 = "./assets/figma/1ea5d289-a38e-408c-b92f-a26175ea7aeb.png";
const img2026923384 = "./assets/figma/1a3b68a3-6e0e-4b18-8d4d-4cdacf65ccfa.png";
const img2026923385 = "./assets/figma/06fc82b9-1f57-4f3e-9650-6d3cbe3b5f0b.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/03b99962-39ad-40e6-8733-504dc981b20b.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";

export default function TeamGraphic2HoverPostcards() {
  return (
    <div className="s0 s1" data-node-id="886:751" data-name="TEAM_GRAPHIC_2/HOVER_POSTCARDS">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s7 s235 s9 s10 s236" src={imgTeamGraphic2HoverPostcards} />
        </div>
      </div>
      <div className="s2 s12 s13 s617 s15" data-node-id="886:753" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s20 s618 s22" data-node-id="886:754">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="886:755">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="886:756">
            PROJECT OVERVIEW
          </p>
          <p className="s649 s39 s0 s28 s37 s34" data-node-id="886:757">
            POSTERS · A2 · 4<br aria-hidden />
            GUIDE CARDS · 160 × 100 MM · 9<br aria-hidden />
            POSTCARDS · 100 × 150 MM · 8<br aria-hidden />
            <br aria-hidden />
          </p>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="886:758">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="886:759">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="886:760">
            MEMBERS
          </p>
          <p className="s649 s39 s0 s28 s37 s34" data-node-id="886:761">
            강다원
            <br aria-hidden />
            고이룸
            <br aria-hidden />
            박성연
            <br aria-hidden />
            박세현
          </p>
        </div>
      </div>
      <p className="s23 s2 s649 s32 s52 s27 s29 s33 s619 s54" data-node-id="886:762">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <p className="s23 s2 s31 s32 s621 s27 s29 s61 s622 s54" data-node-id="886:766">
        GRAPHIC 2
      </p>
      <p className="s23 s2 s31 s32 s63 s27 s29 s64 s626 s66" data-node-id="886:768">
        WORK
      </p>
      <div className="s2 s16 s17 s627 s18 s36 s63 s628 s66" data-node-id="886:769">
        <a className="s141 s335 s336 s337 s338 s0 s28" data-node-id="886:770">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="886:771" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s341 s342 s9 s10 s343" src={img2026923382} />
            </div>
          </div>
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="886:773" />
        </a>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="886:775">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="886:776" data-name="이미지 2026. 9. 2. 오후 3.37 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s629 s630 s9 s631 s632" src={img2026923372} />
            </div>
          </div>
          <div className="s80 s192 s81 s69 s633 s340 s82 s0 s70 s198 s71" data-node-id="886:778" />
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="886:780">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="886:781" data-name="이미지 2026. 9. 2. 오후 3.37 3">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s634 s635 s9 s636 s637" src={img2026923373} />
            </div>
          </div>
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="886:783" />
        </div>
      </div>
      <div className="s2 s16 s17 s627 s18 s63 s639 s66" data-node-id="886:785">
        <div className="s335 s336 s337 s36 s338 s0 s28" data-node-id="886:786">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="886:787" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s341 s640 s9 s641 s343" src={img2026923383} />
            </div>
          </div>
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="886:789" />
        </div>
        <div className="s69 s0 s70 s28 s71" data-node-id="1026:426" data-name="이미지 2026. 9. 2. 오후 3.38 2">
          <img alt="" className="s2 s3 s9 s105 s4 s70 s1" src={img2026923384} />
        </div>
        <a className="s141 s335 s336 s337 s36 s338 s0 s28" data-node-id="886:796">
          <div className="s244 s192 s650 s651 s652 s0 s70 s198 s248" data-node-id="886:797" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <img alt="" className="s2 s3 s9 s105 s4 s70 s1" src={img2026923385} />
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="886:798" />
          <div className="s192 s69 s653 s340 s82 s4 s0 s70 s198 s146 s71" data-node-id="886:799">
            <div aria-hidden className="s2 s3 s70" style={{ backgroundImage: "linear-gradient(90deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%), linear-gradient(90deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.16) 100%)" }} />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s192 s31 s654 s447 s27 s0 s198 s251 s115 s138 s253 s54" data-node-id="886:800">
            <p className="s249 s40">POST</p>
            <p className="s249">CARDS</p>
          </div>
        </a>
      </div>
      <div className="s2 s623 s648 s620 s625" data-node-id="1041:12" data-name="이미지 1203 2">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={img2026923383} />
      </div>
      <div className="s23 s2 s16 s17 s24 s25 s26 s55 s27 s29 s620 s57" data-node-id="1062:175">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="1062:176">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="1062:177">
          <p className="s39 s40">{`그래픽 2팀은 유리관을 연결하고 조립한 타이포그래피로 DING AI LAB의 이름과 실험실이라는 공간적 특성을 시각화했다. `}</p>
          <p className="s39 s40">{`기하학적 형태와 색의 그라데이션이 겹치고 어우러지는 배경을 통해 다양한 아이디어가 모여 조화를 이루는 모습을 표현했으며, `}</p>
          <p className="s39 s40">{`텍스트를 그래픽과 연결해 활동 순서와 슬로건의 정보 위계를 정리했다. 엽서에는 서로 다른 AI의 특성과 아이디어가 변화·확장되는 과정을 `}</p>
          <p className="s39 s40">{`고유 색상, 투명 파이프와 구체로 담았다. 8가지 AI 가이드 카드에는 핵심 기능, 활용 분야, 프롬프트 예시, 사용 팁과 주의사항을 캐릭터와 `}</p>
          <p className="s39">{`색상으로  구분해 복잡한 정보를 친근하고 명확하게 전달했다.`}</p>
        </div>
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="886:801">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="886:802" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="886:803">
          <div className="s111 s0 s28 s112" data-node-id="886:804" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="886:809">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="886:810">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="886:811">
            <p className="s23 s301 s302 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="886:812">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="886:813">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="886:814">
            <p className="s23 s301 s302 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="886:815">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="886:816">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="886:817">
            <p className="s23 s301 s302 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="886:818">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="886:819">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}